import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import ActionForm from "components/actions/ActionForm";
import { updateAction } from "graphql/mutations";
import { getAction } from "graphql/queries";

const ActionUpdateForm = ({ actionId, onSuccess }) => {
  const navigate = useNavigate();
  const [action, setAction] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        description,
        shortName,
        valueType,
        values,
        errorMsg,
        successMsg,
        icon,
        iconColor,
      } = valuesParam;

      await API.graphql({
        query: updateAction.replaceAll("__typename", ""),
        variables: {
          input: {
            id: actionId,
            name,
            description,
            shortName,
            valueType,
            values: JSON.stringify(values),
            errorMsg,
            successMsg,
            icon,
            iconColor,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/actions");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchAction(id) {
    try {
      const actionData = await API.graphql(graphqlOperation(getAction, { id }));
      const actionItem = actionData.data.getAction;
      if (!actionItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/actions");
        return;
      }
      setAction({
        ...actionItem,
        values: JSON.parse(actionItem.values ?? "[]"),
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchAction(actionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionId]);

  if (!action) return <Loader />;

  return (
    <div>
      <ActionForm onSubmit={onSubmit} type="update" initialValues={action} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Acción",
    successUpdated: "Acción actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la acción",
    },
  },
});

export default ActionUpdateForm;
